import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, TextField, Grid, Button, InputLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppState } from '../../../state';
import { Share } from '@mui/icons-material';

const GutterBottomTypography = styled(Typography)({
  marginBottom: '1em',
});

const InputContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '1.5em 0 3.5em',
  '& div:not(:last-child)': {
    marginRight: '1em',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '1.5em 0 2em',
  },
}));

const TextFieldContainer = styled('div')({
  width: '100%',
});

const ContinueButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const CaptionFont = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.64rem',
  color: 'red',
});

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  topicName: string;
  setName: (name: string) => void;
  setRoomName: (roomName: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({
  name,
  roomName,
  setName,
  setRoomName,
  handleSubmit,
  topicName,
}: RoomNameScreenProps) {
  const { user, meeting } = useAppState();
  console.log(meeting, 'meeting');
  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleRoomNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomName(event.target.value);
  };

  // console.log("Room-name --- MEETING--",meeting);

  let hasUsername = user?.displayName ? true : false;

  if (meeting && Boolean(meeting.isChaperoning) === true) {
    setName('Chaperoning Mode');
    hasUsername = true;
  }
  // else {
  //   if (meeting && meeting && meeting.is_anonymous) {
  //     setName('Anonymous Participant');
  //     hasUsername = true;
  //   }
  // }

  // const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;
  const handleCopyLink = async () => {
    navigator.clipboard.writeText(encodeURI(meeting?.join_link));
    alert('Link copied successfully.');
  };

  return (
    <>
      <GutterBottomTypography variant="h5">
        {topicName ? `Join ${topicName}` : roomName ? `Join ${roomName}` : 'Join a Meeting'}
        {meeting && Boolean(meeting.isChaperoning) === true ? ' (Chaperoning Mode)' : ''}
      </GutterBottomTypography>
      <Typography variant="body1">
        {/* {hasUsername
          ? "Enter the name of a room you'd like to join."
          : "Enter your name and the name of a room you'd like to join"} */}
        {/* {roomName
          ? "Enter your name."
          : hasUsername
            ? "Enter the Meeting ID you'd like to join."
            : "Enter your Name and the Meeting ID you'd like to join"} */}
        {roomName
          ? hasUsername
            ? ''
            : 'Enter your name.'
          : hasUsername
            ? "Enter the Meeting ID you'd like to join."
            : "Enter your Name and the Meeting ID you'd like to join"}
      </Typography>
      {meeting?.is_anonymous && (
        <CaptionFont variant="caption">
          (Please note that any name added below will not be visible to the other participants of this call.)
        </CaptionFont>
      )}
      <form onSubmit={handleSubmit}>
        <InputContainer>
          {!hasUsername && (
            <TextFieldContainer>
              <InputLabel shrink htmlFor="input-user-name">
                Your Name
              </InputLabel>
              <TextField
                id="input-user-name"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={handleNameChange}
              />
            </TextFieldContainer>
          )}
          {!roomName && (
            <TextFieldContainer>
              <InputLabel shrink htmlFor="input-room-name">
                Meeting ID
              </InputLabel>
              <TextField
                autoCapitalize="false"
                id="input-room-name"
                variant="outlined"
                fullWidth
                size="small"
                value={roomName}
                onChange={handleRoomNameChange}
              />
            </TextFieldContainer>
          )}
        </InputContainer>
        <Grid container justifyContent="flex-end">
          <ContinueButton
            variant="contained"
            type="submit"
            color="primary"
            disabled={!name || !roomName}
            style={!name || !roomName ? {} : { color: "white" }}
          >
            Continue
          </ContinueButton>
          {!!meeting?.is_shareable !== false && (
            <ContinueButton
              variant="contained"
              type="button"
              color="primary"
              onClick={() => {
                handleCopyLink();
              }}
              style={{ marginLeft: '10px', color: "white" }}
            >
              <Share /> Share Meeting URL
            </ContinueButton>
          )}
        </Grid>
      </form>
    </>
  );
}